import { BaseUser } from '~/modules/users/model'

export const initialBaseUser: BaseUser = {
  email: {
    address: '',
  },
  name: {
    firstName: '',
    lastName: '',
  },
}
